<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Remove From Recruitment Depth Chart
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label" />
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="removeRecruitmentDepthChartPersonId"
        placeholder="Select person..."
      >
        <el-option
          v-for="item in removablePeople"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>

    <p v-if="validationError === true" style="color: red;">
      A person is required.
    </p>
    <br><br>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Remove
      </p-button>
      <p-button type="danger" v-if="saving">
        Removing...
      </p-button>
            &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const RecruitmentDepthChartsRepository = RepositoryFactory.get('recruitmentDepthCharts');

function validateForm(removeRecruitmentDepthChartPersonId) {
    return !!removeRecruitmentDepthChartPersonId;
}

export default {
    name: 'RemoveRecruitmentDepthChartModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: false,
            removablePeople: [],
            removeRecruitmentDepthChartPersonId: '',
            error: '',
            saving: false
        };
    },
    computed: {
        ...mapState({
            locations: (state) => state.userLocations,
        }),
        ...mapGetters({
            locationFromStore: 'lastLocation'
        }),
        locationId: {
            get() {
                return this.locationFromStore;
            },
            set(newLocation) {
                this.$store.commit('setLastLocation', newLocation);
            }
        }
    },
    methods: {
        handleSave() {
            this.saving = true;
            if (!validateForm(this.removeRecruitmentDepthChartPersonId)) {
                this.validationError = true;
                this.saving = false;
                return;
            }

            RecruitmentDepthChartsRepository.removeRecruitmentDepthChart(this.removeRecruitmentDepthChartPersonId)
                .then((response) => {
                    // console.log('yay');
                    this.saving = false;
                    this.$emit('recruitmentDepthChartChange');
                    this.$emit('save');
                    this.$message(response.data.message);
                })
                .catch((error) => {
                    this.saving = false;
                    this.$message.error(error.response.data.message);
                });

            this.$emit('close');

            this.removeRecruitmentDepthChartPersonId = '';
            this.validationError = false;
        },
        handleClose() {
            this.removeRecruitmentDepthChartPersonId = '';
            this.validationError = false;
            this.$emit('close');
        },
        getRemovableRecruitmentDepthChartList() {
            RecruitmentDepthChartsRepository.getRemovableRecruitmentDepthChartList(this.locationId)
                .then((response) => {
                    this.removablePeople = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    props: {
        show: Boolean,
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getRemovableRecruitmentDepthChartList();
            }
        }
    },
    created() {
        this.getRemovableRecruitmentDepthChartList();
    },
};
</script>
